var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobIndex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 19H4.5C4 19 3.5 19 3 18.5C2.5 18 2.5 17.5 2.5 17V10.1C2.5 10.0448 2.45523 10 2.4 10H0.741421C0.652331 10 0.607714 9.89229 0.670711 9.82929L9.42929 1.07071C9.46834 1.03166 9.53166 1.03166 9.57071 1.07071L18.3293 9.82929C18.3923 9.89229 18.3477 10 18.2586 10H16.6C16.5448 10 16.5 10.0448 16.5 10.1V17C16.5 17.5 16.5 18 16 18.5C15.5 19 15 19 14.5 19H12.125M7.125 19H12.125M7.125 19C7.125 19 7.125 13.5 7.125 13C7.125 12.5 7.125 12 7.625 11.5C8.125 11 8.625 11 9.125 11C9.625 11 9.625 11 10.125 11C10.625 11 11.125 11 11.625 11.5C12.125 12 12.125 12.5 12.125 13C12.125 13.5 12.125 19 12.125 19",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobIndex);
export default __webpack_public_path__ + "static/media/mob_index.1959788d8bca0f0445d704770fd3be6e.svg";
export { ForwardRef as ReactComponent };